<div class="section-title d-flex flex-column align-items-center mt-5 ts-section-title" loading="lazy" [ngClass]="data.class">

  <h2 [ngClass]="data?.title.class" [style.fontSize]="data.titleSize">{{data.title.text}}</h2>
  <ng-container *ngIf="data?.paragraphs">
    <p *ngFor="let paragraph of data.paragraphs" [ngClass]="paragraph.class">{{paragraph.text}}</p>
  </ng-container>

</div>

